import React , {useEffect} from 'react';
import RadioComponent from '../Components/RadioComponent'

/**
 * @param {[][]} props.components - 2d array  which contains for every row of a data element the inside components
 * @param {setState} props.setComponents - hook method that handle components variable 
 * @param {[][]} props.typeFields - 2d array which contains for every row of a data element the types of the inside components  
 * @param {setState} props.setTypeFields - hook method that handle typeFields variable
 * @param {number} props.formRowIndex - index of examined row of a data element
 * @param {number} props.indexComponent - index of radio component inside row with components
 * @param {setMethod} props.setClickedChangeElement - hook method that updates clickedChangeElement
 * @param {boolean} props.openAlert - state that open/closes data element pop up
 * @param {boolean} props.clickedChangeElement - state that defines any inside component has been deleted and all components need to render again 
 * @returns radio component inside list element
 */
const RadioDataComponent = (props) => {

    const {
        components,
        setComponents,
        typeFields,
        setTypeFields,
        formRowIndex,
        indexComponent,
        setClickedChangeElement,
        openAlert,
        clickedChangeElement,
    }= props;

    const [labels, setLabels] = React.useState([]); // Labels of radio component 
    const [clickedDeleteFirst, setClickedDeleteFirst] = React.useState(false); // State that defines if first option has clicked to be deleted
    const [lockDeleteOption, setLockDeleteOption] = React.useState(false); // State that defines that the deletion of first option has been locked because it is the only one

    /**
     * It is runned to initialize the labels of radio component and when 
     * an inside component of data element has been deleted
     */
    useEffect( () => {
        
        setLabels(components[formRowIndex][indexComponent].labels)

    },[openAlert, clickedChangeElement])

    // It is runned every time that first option is clicked to deleted
    useEffect( () => {
        if(clickedDeleteFirst === true){

            const lengthOptions = components[formRowIndex][indexComponent].labels.length;

            // If first option is the only one set lockDeleteOption to true and render again useEffect
            if(lengthOptions === 1){
                setLockDeleteOption(true);
            }
            setClickedDeleteFirst(false);
        }
        // If lockDeleteOption is true wait 2 seconds in order to display the error message and then set lockDeleteOption to false again
        if(lockDeleteOption === true){
            setTimeout(() => {
                setLockDeleteOption(false)  
            }, 2000);
        }

    },[clickedDeleteFirst])


    // Delete radio component method
    const deleteComponent = () => {
        const tempComponents = [...components];
        tempComponents[formRowIndex].splice(indexComponent,1);
        setComponents(tempComponents);

        const tempTypeFields = [...typeFields];
        tempTypeFields[formRowIndex].splice(indexComponent,1);
        setTypeFields(tempTypeFields);
        setClickedChangeElement(true); // Set clickedChangeElement to true in order to rerender all components of data element
    } 

    // Add option inside radio component method
    const addOption = () => {

        const tempComponents = [...components];

        const optionsLength = components[formRowIndex][indexComponent].labels.length;

        tempComponents[formRowIndex][indexComponent].labels.push(`Radio${(optionsLength+1).toString()}`)
        setComponents(tempComponents);

        setClickedChangeElement(true); // Set clickedChangeElement to true in order to rerender all components of data element
    }

    // Delete option of radio data component 
    const deleteOption = (index) => {

        const optionsLength = components[formRowIndex][indexComponent].labels.length;

        if(index === 0 && optionsLength === 1){
            setClickedDeleteFirst(true);
        }
        else{

            const tempComponents = [...components];
            tempComponents[formRowIndex][indexComponent].labels.splice(index,1);
            setComponents(tempComponents);

            setClickedChangeElement(true); // Set clickedChangeElement to true in order to rerender all components of data element
        }

    }

    return (
        <RadioComponent
            deleteComponent = {deleteComponent}
            options={labels}
            addOption={addOption}
            deleteOption={deleteOption}
            lockDeleteOption={lockDeleteOption}
        />
    )

}

export default RadioDataComponent;